import React, { useContext } from 'react';
import styled from 'styled-components';
import Select from '../forms/Select';
import { TableContext } from './Table';
import Row from '../layout/Row';
import { SCREEN_MAX_WIDTH } from '../../constants/config';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 1em;

    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        align-items: flex-start;
        flex-direction: column;
    }
`

const ItemsPerSelector = ({ ...props }) => {
    const { tableData, currentPage, setItemsPerPage, setCurrentPage, itemsPerPage, disablePagerResults } = useContext(TableContext);

    const options = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 15, value: 15 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
    ]

    const start = (currentPage - 1) * itemsPerPage + 1;
    const end = Math.min(currentPage * itemsPerPage, tableData.length);

    if (!options.find(e => e.value === itemsPerPage)) {
        options.push({
            label: itemsPerPage,
            value: itemsPerPage
        })
    }

    return (
        <Row>
            <Wrapper>
                <Select
                    value={itemsPerPage}
                    onChange={(e) => {
                        setCurrentPage(1)
                        setItemsPerPage(parseInt(e.target.value))
                    }}
                    options={options}
                    standalone
                    aria-label='Items per page'
                />
            </Wrapper>
            {!disablePagerResults && (
                tableData.length > itemsPerPage ?
                    <Row><b>{start} - {end}</b> of <b>{tableData.length}</b></Row> :
                    <span><b>{tableData.length}</b> results</span>
            )}
        </Row>
    );
}

export default ItemsPerSelector;